AuthRoute = require 'mixins/authenticated-route'

{ timedPromise } = require 'utils/rsvp'

App.DishGroupsIndexRoute = Em.Route.extend AuthRoute,
  store: Em.inject.service()
  
  model: ->
    @store.find('dish_group').then (groups) =>
      groups.forEach (group) => 
        group.set('relatedDishes', group.get('dish_ids').map (id) =>
          @store.find 'dish', id
        )
